import { createAsyncThunk } from '@reduxjs/toolkit';
import type TwilioApi from 'api/TwilionApi';
import { DEBOUNCE_TIMEOUT } from 'thunks/thunks.config';
import debounce from 'utils/debounce';
import { logger } from 'utils/logger';

export const resendPhoneVerificationThunk = (api: TwilioApi) => {
  const debouncedApiCall = debounce(
    (data: { applicationId: string; submissionId: string }) => api.resendVerification(data),
    DEBOUNCE_TIMEOUT,
  );

  return createAsyncThunk(
    'twilio/resendPhoneVerification',
    async (data: { applicationId: string; submissionId: string }) => {
      try {
        logger.info(`Twilio resend verification for application ${data.applicationId}`);

        return await debouncedApiCall(data);
      } catch (error) {
        logger.error(
          `Twilio resend verification failed for application ${data.applicationId}`,
          error,
        );

        throw error;
      }
    },
  );
};
